// extracted by mini-css-extract-plugin
module.exports = {"modalOuter":"_2pH_J","headerWrap":"_2STv4","heading":"r8rEe","boxWrapper":"_1Sriy","mediaWrapper":"_1OgIc","boxHeading":"_2qiHp","boxSubHeading":"_8-XKQ","loading":"_1mVK6"};